"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const offchainAccountPoolToken_1 = __importDefault(require("./offchainAccountPoolToken"));
class OffchainAccountLendingVault extends offchainAccountPoolToken_1.default {
    constructor(account, lendingVault) {
        super();
        this.getAccount = () => this.account;
        this.getPoolToken = () => this.poolToken;
        this.getVaultAddress = () => this.poolToken.getVaultAddress();
        this.account = account;
        this.poolToken = lendingVault;
    }
    getLendingVaultPosition() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingVaultsUserData = yield this.account.getLendingVaultsUserData();
            if (!lendingVaultsUserData)
                return undefined;
            return lendingVaultsUserData[this.getVaultAddress()];
        });
    }
    getAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingVaultPosition = yield this.getLendingVaultPosition();
            if (!lendingVaultPosition)
                return 0;
            const exchangeRate = yield this.poolToken.getCurrentExchangeRate();
            const tokenBalance = parseFloat(lendingVaultPosition.tokenBalance);
            return tokenBalance * exchangeRate;
        });
    }
    getEarnings() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingVaultPosition = yield this.getLendingVaultPosition();
            if (!lendingVaultPosition)
                return 0;
            const exchangeRate = yield this.poolToken.getCurrentExchangeRate();
            const tokenBalance = parseFloat(lendingVaultPosition.tokenBalance);
            const cumulativeEarnings = parseFloat(lendingVaultPosition.cumulativeEarnings);
            const lastExchangeRate = parseFloat(lendingVaultPosition.lastExchangeRate);
            const newEarnings = (exchangeRate - lastExchangeRate) * tokenBalance;
            return cumulativeEarnings + newEarnings;
        });
    }
    getEarningsUSD() {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenPrice = yield this.poolToken.getTokenPriceAccurate();
            const earnings = yield this.getEarnings();
            return earnings * tokenPrice;
        });
    }
}
exports.default = OffchainAccountLendingVault;
